import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Button, Stack } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { apiService } from '../services/apiService';
import { Link as RouterLink } from 'react-router-dom';

const Notifications: React.FC = () => {
  const { authenticated, login } = useAuth();
  const [items, setItems] = useState<any[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!authenticated) {
      setItems(null);
      return;
    }
    (async () => {
      try {
        const resp = await apiService.getMyNotifications(50, 0);
        if (cancelled) return;
        setItems(Array.isArray(resp.data?.items) ? resp.data.items : []);
        // Best-effort mark read (no-op server side)
        try { await apiService.markMyNotificationsRead({}); } catch {}
      } catch (e: any) {
        if (cancelled) return;
        setError(e?.response?.data?.detail || 'Failed to load notifications');
        setItems([]);
      }
    })();
    return () => { cancelled = true; };
  }, [authenticated]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Notifications</Typography>
      {!authenticated ? (
        <Card>
          <CardContent>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" color="textSecondary">Sign in to see your personalized updates.</Typography>
              <Button variant="contained" onClick={login}>Sign In</Button>
            </Stack>
          </CardContent>
        </Card>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : items === null ? (
        <Typography color="textSecondary">Loading…</Typography>
      ) : items.length === 0 ? (
        <Typography color="textSecondary">No notifications yet. Follow bills to get updates here.</Typography>
      ) : (
        <Card>
          <CardContent>
            <List>
              {items.map((it: any, idx: number) => {
                const b = it.bill || {};
                const to = (b.congress && b.bill_type && b.bill_number) ? `/bills/${b.congress}/${b.bill_type}/${b.bill_number}` : undefined;
                const primary = b.title || `${(b.bill_type || '').toUpperCase()} ${b.bill_number || ''}`;
                const secondary = b.latest_action_text || b.latest_action_date || '';
                return (
                  <ListItem key={idx} divider component={to ? (RouterLink as any) : 'li'} to={to || ''}>
                    <ListItemText primary={primary} secondary={secondary} />
                  </ListItem>
                );
              })}
            </List>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default Notifications;
